export default __webpack_public_path__ + "static/media/logo.af4fff82.svg";